import { http_get } from './helpers';
import { version } from './config';
import {
 ProductDetail, ProductProperty, ProductStandardCode, ProductQuality, ProductTechDoc, ProductCorrelation,
} from './types';

// GET /api/v{version}/m/ProductDetail/{id}
// 详情
export const getProduct = http_get<
    {
        id: string;
    },
    ProductDetail
>(`/api/v${version}/m/ProductDetail/{id}`);

// GET /api/v{version}/m/ProductDetail/{id}/Properties
// 属性与规格
export const getProductProperties = http_get<
    {
        pvId: string;
        id: string;
    },
    ProductProperty[]
>(`/api/v${version}/m/ProductDetail/{id}/Properties`);

// GET /api/v{version}/m/ProductDetail/{id}/StandardCodes
// 标准编码
export const getProductStandardCodes = http_get<
    {
        pvId: string;
        id: string;
    },
    ProductStandardCode[]
>(`/api/v${version}/m/ProductDetail/{id}/StandardCodes`);

// GET /api/v{version}/m/ProductDetail/{id}/CertAndRating
// 认证与评级
export const getProductQuality = http_get<
    {
        pvId: string;
        id: string;
    },
    ProductQuality
>(`/api/v${version}/m/ProductDetail/{id}/CertAndRating`);

// GET /api/v{version}/m/ProductDetail/{id}/TechDocs
// 技术文档
export const getProductTechDocs = http_get<
    {
        pvId: string;
        id: string;
    },
    ProductTechDoc[]
>(`/api/v${version}/m/ProductDetail/{id}/TechDocs`);

// GET /api/v{version}/m/ProductDetail/{id}/Correlations
// 相关产品
// todo: 不符合设计
export const getProductCorrelations = http_get<
    {
        pvId: string;
        id: string;
    },
    ProductCorrelation[]
>(`/api/v${version}/m/ProductDetail/{id}/Correlations`);

// GET /api/v{version}/m/ProductDetail/{id}/Files
// 产品文件
// todo: 设计稿没这个啊？

export const downloadModelFile = http_get<
    {
        extensionName: string;
        pvId: string;
        productId: string;
    },
    any
>(`/api/v${version}/m/ProductFiles/DownloadModelFile`);

// 下载模型
export const getSignedUrl = http_get<
    {
        extensionName: string;
        pvId: string;
        productId: string;
    },
    any
>(`/api/v${version}/m/ProductFiles/SignedUrl`);
